import classNames from 'classnames';
import React from 'react';
import styles from './layout.css';

export type RowsProps = {
  children?: React.ReactNode;
  spacing?: number;
  xalign?: 'start' | 'center' | 'end' | 'stretch';
  yalign?: 'start' | 'center' | 'end' | 'space-between' | 'space-around';
  fixedHeight?: boolean;
  fixedWidth?: boolean;
};

export type InlineProps = {
  children?: React.ReactNode;
  spacing?: number;
  yalign?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
  xalign?: 'start' | 'center' | 'end' | 'space-between' | 'space-around';
  wrap?: boolean;
};

export function Rows({
  children,
  spacing = 16,
  yalign,
  xalign = 'stretch',
  fixedHeight,
  fixedWidth = true,
}: RowsProps) {
  return (
    <div
      className={classNames(
        styles.rows,
        fixedHeight && styles.fixedHeight,
        fixedWidth && styles.fixedWidth,
      )}
      style={{
        gap: spacing + 'px',
        alignItems: xalign,
        justifyContent: yalign,
      }}
    >
      {children}
    </div>
  );
}

export function Inline({
  children,
  spacing = 16,
  yalign = 'start',
  xalign = 'start',
  wrap,
}: InlineProps) {
  return (
    <div
      className={styles.inline}
      style={{
        gap: spacing + 'px',
        alignItems: yalign,
        justifyContent: xalign,
        flexWrap: wrap ? 'wrap' : undefined,
      }}
    >
      {children}
    </div>
  );
}

// TODO maybe rename this to Grow?
export function SpacerGrow() {
  return <div className={styles.grow} />;
}

export function Grow({ children }: { children?: React.ReactNode }) {
  return <div className={styles.grow}>{children}</div>;
}
